import { h, Component } from 'preact';
import PageLink from 'components/pageLink/pageLink';
// import Store from 'store/store';
// import * as actions from 'store/actions';

// import Breadcrumb from 'components/breadcrumb/breadcrumb';

import s from 'components/pages/error-404/error-404.sss';

export default class Error404 extends Component {

	render() {
		return (
			<div class={s.wrapper}>
				{/* <Breadcrumb class={s.breadcrumb} location={['landing', '404']} /> */}
				<h2 class={s.title}>Lost in the universe...</h2>
				<p class={s.content}>Page not found</p>
				<PageLink to={'home'} class={s.link}>Return to home</PageLink>
			</div>
		);
	}

}